// removed by extract-text-webpack-plugin
module.exports = {"loader":"_-src-components-LoaderPanel-styles---loader---2Onid"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoaderPanel/styles.css
// module id = 649
// module chunks = 0